import { render, staticRenderFns } from "./organization-information.html?vue&type=template&id=46d566a2&"
import script from "./OrganizationInformation.vue?vue&type=script&lang=js&"
export * from "./OrganizationInformation.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports